import {MutationTree} from "vuex";
import {TarificationState} from "@/store/tarification/types";

export const mutations: MutationTree<TarificationState> = {
  setTariffZones:(state, payload) => {
    state.tariffZones = payload
  },
  setTariffZoneItem:(state, payload) => {
    state.tariffZone = payload
  },
  setTariffZoneGroupItem:(state, payload) => {
    state.tariffZoneGroup = payload
  },
  setTariffs:(state, payload) => {
    state.tariffs = payload
  },
  setTariff:(state, payload) => {
    state.tariff = payload
  },
}